/* ============================================================
   REBARATIN — comportamiento del tema
   Carrito con la API Ajax de Shopify + Section Rendering API:
   el HTML del carrito lo genera Liquid (sections/cart-drawer.liquid)
   y aquí solo se pide de nuevo y se reemplaza.
   ============================================================ */
(function () {
  'use strict';

  var CART_SECTION = 'cart-drawer';
  var theme = window.theme || { routes: {}, strings: {} };

  function root() {
    return theme.routes.root && theme.routes.root !== '/' ? theme.routes.root.replace(/\/$/, '') : '';
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Carrito lateral ---------- */
  var lastFocus = null;

  function drawerEls() {
    return { drawer: $('#CartDrawer'), overlay: $('#CartOverlay') };
  }

  function openCart() {
    var els = drawerEls();
    if (!els.drawer) { window.location.href = theme.routes.cart; return; }
    lastFocus = document.activeElement;
    els.drawer.classList.add('on');
    els.overlay && els.overlay.classList.add('on');
    els.drawer.setAttribute('aria-hidden', 'false');
    var close = $('[data-cart-close]', els.drawer);
    close && close.focus();
  }

  function closeCart() {
    var els = drawerEls();
    if (!els.drawer) return;
    els.drawer.classList.remove('on');
    els.overlay && els.overlay.classList.remove('on');
    els.drawer.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderCartSection(html, keepOpen) {
    if (!html) return;
    var wrapper = document.getElementById('shopify-section-' + CART_SECTION);
    if (!wrapper) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-' + CART_SECTION) || doc.body.firstElementChild;
    if (!fresh) return;
    wrapper.innerHTML = fresh.innerHTML;
    syncCount();
    if (keepOpen) {
      var els = drawerEls();
      els.drawer && els.drawer.classList.add('on');
      els.overlay && els.overlay.classList.add('on');
      els.drawer && els.drawer.setAttribute('aria-hidden', 'false');
    }
  }

  function syncCount() {
    var state = $('[data-cart-state]');
    if (!state) return;
    var count = parseInt(state.getAttribute('data-count'), 10) || 0;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function changeLine(line, quantity) {
    var drawer = $('#CartDrawer');
    drawer && drawer.classList.add('is-busy');
    return postJSON(root() + '/cart/change.js', {
      line: line,
      quantity: quantity,
      sections: [CART_SECTION],
      sections_url: window.location.pathname
    }).then(function (cart) {
      renderCartSection(cart.sections && cart.sections[CART_SECTION], true);
    }).catch(function (err) {
      alertError(err);
    }).finally(function () {
      var d = $('#CartDrawer');
      d && d.classList.remove('is-busy');
    });
  }

  function alertError(err) {
    var msg = (err && (err.description || err.message)) || theme.strings.error;
    var box = $('[data-cart-error]');
    if (box) { box.textContent = msg; box.hidden = false; }
    else { console.error(msg); }
  }

  /* ---------- Agregar al carrito ---------- */
  function addToCart(form) {
    var btn = $('[type="submit"]', form);
    var label = btn ? btn.innerHTML : '';
    btn && btn.classList.add('is-loading');
    btn && btn.setAttribute('aria-busy', 'true');

    var data = new FormData(form);
    data.append('sections', CART_SECTION);
    data.append('sections_url', window.location.pathname);

    var errorBox = $('[data-form-error]', form);
    if (errorBox) errorBox.hidden = true;

    return fetch(root() + '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw json;
        return json;
      });
    }).then(function (res) {
      if (btn) {
        btn.innerHTML = theme.strings.added;
        btn.classList.add('ok');
        setTimeout(function () { btn.innerHTML = label; btn.classList.remove('ok'); }, 1200);
      }
      if (res.sections && res.sections[CART_SECTION]) {
        renderCartSection(res.sections[CART_SECTION], false);
        openCart();
      } else {
        window.location.href = theme.routes.cart;
      }
    }).catch(function (err) {
      var msg = (err && (err.description || err.message)) || theme.strings.error;
      if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; }
      else { alertError(err); }
    }).finally(function () {
      btn && btn.classList.remove('is-loading');
      btn && btn.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-product-form]')) return;
    if (theme.cartType !== 'drawer' || !$('#CartDrawer')) return;
    e.preventDefault();
    addToCart(form);
  });

  /* ---------- Clics delegados ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var opener = t.closest('[data-cart-open]');
    if (opener && $('#CartDrawer')) { e.preventDefault(); openCart(); return; }

    if (t.closest('[data-cart-close]') || t.matches('#CartOverlay')) { e.preventDefault(); closeCart(); return; }

    var lineBtn = t.closest('[data-line-change]');
    if (lineBtn) {
      e.preventDefault();
      changeLine(parseInt(lineBtn.getAttribute('data-line'), 10), parseInt(lineBtn.getAttribute('data-quantity'), 10));
      return;
    }

    var step = t.closest('[data-qty-step]');
    if (step) {
      var input = $('input', step.closest('.qty'));
      if (!input) return;
      var min = parseInt(input.min || '1', 10);
      var next = Math.max(min, (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-qty-step'), 10));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var thumb = t.closest('[data-gallery-thumb]');
    if (thumb) {
      e.preventDefault();
      var gallery = thumb.closest('[data-gallery]');
      var main = $('[data-gallery-main] img', gallery);
      var src = $('img', thumb);
      if (main && src) {
        main.src = thumb.getAttribute('data-full');
        main.srcset = thumb.getAttribute('data-srcset') || '';
        main.alt = src.alt;
      }
      $$('[data-gallery-thumb]', gallery).forEach(function (b) { b.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
      return;
    }

    var scroller = t.closest('a[href^="#"]');
    if (scroller && scroller.getAttribute('href').length > 1) {
      var target = document.getElementById(scroller.getAttribute('href').slice(1));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  /* ---------- Selector de variantes ---------- */
  function money(cents, format) {
    var value = (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return (format || '${{amount_no_decimals}}').replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-variant-select]');
    if (!select) return;
    var scope = select.closest('[data-product]');
    var dataEl = $('script[data-variants]', scope);
    if (!dataEl) return;
    var info = JSON.parse(dataEl.textContent);
    var variant = info.variants.find(function (v) { return String(v.id) === select.value; });
    if (!variant) return;

    $$('[data-price]', scope).forEach(function (el) { el.textContent = money(variant.price, info.money_format); });
    $$('[data-compare]', scope).forEach(function (el) {
      var show = variant.compare_at_price && variant.compare_at_price > variant.price;
      el.hidden = !show;
      if (show) el.textContent = money(variant.compare_at_price, info.money_format);
    });
    $$('[data-off]', scope).forEach(function (el) {
      var show = variant.compare_at_price && variant.compare_at_price > variant.price;
      el.hidden = !show;
      if (show) el.textContent = '-' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
    });
    $$('[data-add-button]', scope).forEach(function (btn) {
      btn.disabled = !variant.available;
      var lbl = $('[data-add-label]', btn);
      if (lbl) lbl.textContent = variant.available ? info.strings.add : info.strings.sold_out;
    });
    if (variant.featured_media) {
      var thumb = $('[data-gallery-thumb][data-media-id="' + variant.featured_media.id + '"]', scope);
      thumb && thumb.click();
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  });

  /* ---------- Productos recomendados ---------- */
  function loadRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.getAttribute('data-loaded')) return;
      el.setAttribute('data-loaded', '1');
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncCount();
    loadRecommendations();
  });
  document.addEventListener('shopify:section:load', function () {
    syncCount();
    loadRecommendations();
  });
})();
